import React, { FC } from 'react';
import Menu from '../ui/Menu';
import Img from '../../assets/images/tap-settings.png';
import IconSvg from '../ui/IconSvg';

type OwnProps = {
  isOpen: boolean;
  onClose: NoneToVoidFunction;
};

const ButtonTooltip: FC<OwnProps> = ({ isOpen, onClose }) => {
  return (
    <Menu
      isOpen={isOpen}
      autoClose={true}
      onClose={onClose}
      positionY='bottom'
      positionX='right'
      noCompact
      className='botton-tooltip'
      //onMouseEnterBackdrop={onMouseEnterBackdrop}
    >
      <div className='close'>
        <IconSvg name='close' w='18' h='18' />
      </div>
      <div className='botton-tooltip-wrap'>
        <img src={Img} alt='Tap Settings' />
        <div className='bubble-title'>Tap Settings to invite friends</div>
      </div>
    </Menu>
  );
};

export default ButtonTooltip;
